module.exports = __webpack_public_path__ + "static/media/publix2_square.dafbdb91.png";